import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 25px;
`;

export const ImageContainer = styled.figure``;

export const ImageElement = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 20px;
  overflow: hidden;
`;

export const ImageCaption = styled.figcaption``;
